import { useEffect, useState } from "react";
import { API_END_POINT } from "../../../constants";
import { Button, Modal } from "react-bootstrap";
import '@progress/kendo-theme-default/dist/all.css';
import '../../../components/Style/OrderStyle.css';
import React from "react";
import { Product, Receipt } from "../../../models/transaction/orderdroppingpointproduct-model";
import { useGetPaymentMode } from "../../../apiclient/common/useGetPaymentModeApi";
import { useLocation } from "react-router-dom";
import { OrderHistory } from "../../../models/transaction/orderhistory-model";
import EditIcon from "../../../assets/images/edit";
import { getDataWithToken, getEndPoint, postData } from "../../../Utils/network.client";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { formatDate } from "@progress/kendo-intl";
import DeleteIcon from "../../../assets/images/delete";
import ZoneCounterModel from "../../../models/transaction/zonecounter-model";


interface DispatchEditProps {
    data: ZoneCounterModel & {
        droppingPointId: number;
        selectedDate: Date;
        routeId: string | number;
        sessionId: string | number;
    };
    onClose?: () => void;
}


const DispatchEntryPage: React.FC<DispatchEditProps> = ({ data, onClose }) => {
    const { droppingPointId, selectedDate, routeId, sessionId } = data;


    const location = useLocation();
    ///const { agentData } = location.state || {};

    const agentData = data;

    let orderZoneId = agentData.zoneId;
    let orderCounterId = agentData.counterId;
    //let orderZoneName = agentData.name; // Grab the passed edit data
    console.log("Agent", agentData);
    const [loadingDetails, setLoadingDetails] = useState<boolean>(false);
    const [droppingPointCode, setdroppingPointCode] = useState<string>("");
    const [totalAmount, setTotalAmount] = useState<number>(0);
    const [showModal, setShowModal] = useState(false);
    const [showGrid, setShowGrid] = useState(false);
    const [isGetClicked, setIsGetClicked] = useState(false);
    //textarea 
    const [droppingPointData, setDroppingPointData] = useState<string>('');
    //receipt
    const [modeOfPayment, setModeOfPayment] = useState<number>(0);
    const [reference, setReference] = useState('');
    const [receivedAmount, setReceivedAmount] = useState('');
    const [receiptId, setReceiptId] = useState<number>(0);
    //ordermain

    const [agentId, setAgentId] = useState(0);
    const [categoryId, setCategoryId] = useState(0);
    const [zoneId, setZoneId] = useState(0);

    const [counterId, setCounterId] = useState(0);
    const [orderNumber, setorderNumber] = useState(0);
    const [isAllowCredit, setisAllowCredit] = useState(false);
    const [isDespatched, setisDespatched] = useState(false);
    const [discountAmount, setdiscountAmount] = useState(0);
    //productDataList
    const [fetchedProductList, setFetchedProductList] = useState<Product[]>([])
    //orderHistoryDataList
    const [orderHistoryList, setOrderHistoryList] = useState<OrderHistory[]>([]);
    const [selectedItem, setSelectedItem] = useState(null);

    //popup
    const [modalTitle, setModalTitle] = useState<string>("");
    const [modalLine1, setModalLine1] = useState("");
    const [modalLine2, setModalLine2] = useState("");
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [isDeleteMode, setIsDeleteMode] = useState(false);
    // droppingpoint for dropdown
    const [modePayment, setmodePaymentData] = useState<{ value: string; label: string }[]>([]);

    const { data: fetchedModePayment } = useGetPaymentMode();

    useEffect(() => {
        if (fetchedModePayment) {
            const mappedmodepayment = fetchedModePayment.map((modepayment: any) => ({
                value: modepayment.id,
                label: modepayment.name,
            }));
            setmodePaymentData(mappedmodepayment);
        }
    }, [fetchedModePayment]);

    useEffect(() => {
        if (droppingPointId && selectedDate && routeId && sessionId) {
            console.log("Received Props:");
            console.log("Dropping Point ID:", droppingPointId);
            console.log("Selected Date:", selectedDate);
            console.log("Route ID:", routeId);
            console.log("Session ID:", sessionId);

            fetchData();
        }
    }, [droppingPointId, selectedDate, routeId, sessionId]);



    const [orderDate, setOrderDate] = useState<Date>(new Date(dayjs().add(0, "months").format("MM/DD/YYYY")));
    const [orderDate2, setOrderDate2] = useState<string>("");
    const [deliveryDate, setDeliveryDate] = useState<Date>(new Date(dayjs().add(1, "days").format("MM/DD/YYYY")));
    const [deliveryDate2, setDeliveryDate2] = useState<string>("");

    const handleDateChange = (value: any) => {
        // const today = new Date();
        const day = value.getDate().toString().padStart(2, '0');
        const month = value.toLocaleString('default', { month: 'short' }).toUpperCase(); // Get short month (e.g., JAN)
        const year = value.getFullYear();
        const formattedDate = new Date(`${year}-${month}-${day}`);
        setOrderDate(formattedDate);

    };

    const handleDateChanges = (value: any) => {
        // const today = new Date();
        const day = value.getDate().toString().padStart(2, '0');
        const month = value.toLocaleString('default', { month: 'short' }).toUpperCase(); // Get short month (e.g., JAN)
        const year = value.getFullYear();
        const formattedDate2 = new Date(`${year}-${month}-${day}`);
        setDeliveryDate(formattedDate2);
    };
    useEffect(() => {

        if (orderDate) {
            const formattedDate1 = dayjs(orderDate).format('ddd MMM DD YYYY ');
            console.log("Formatted Date:", formattedDate1);
            setOrderDate2(formattedDate1);
            // getOrderHistoryList(formattedDate1);
        }
        if (deliveryDate) {
            const formattedDate2 = dayjs(deliveryDate).format('ddd MMM DD YYYY ');
            //console.log("Formatted Date:", formattedDate2);
            setDeliveryDate2(formattedDate2);
        }
    }, [orderDate, deliveryDate]);


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        if (name === 'droppingPointCode') {
            setdroppingPointCode(value);
        } else if (name === 'reference') {
            setReference(value);
        } else if (name === 'receivedAmount') {
            setReceivedAmount(value);
        }
    };

    const fetchData = async () => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        const getProductUrl = getEndPoint(API_END_POINT.ORDER) + `/api/Dispatch/GetProductsForDispatch/${droppingPointId}/${sessionId}/${formattedDate}/${routeId}`;
        try {
            const response = await getDataWithToken<any>(getProductUrl);
            //  params: { droppingPointCode: droppingPointCode, orderdate: orderDate  /* orderdate: '2024-10-01' */ },

            //const droppingPoint = response.data?.result?.droppingPoint || [];
            // setDroppingPointDataList(droppingPoint);

            const product = response?.data?.result?.product || [];

            console.log("prod", product)

            if (product.length) {

                const droppingPoint = product[0];
                const droppingPointId = droppingPoint?.droppingpointId;
                setdroppingPointCode(droppingPoint.droppingPointCode);
                /*     const agentId = droppingPoint?.agentId;
                   const categoryId = droppingPoint?.categoryId;
                   const zoneId = droppingPoint?.zoneId;
                   const routeId = droppingPoint?.routeId;
                   const counterId = droppingPoint?.counterId; */
                const credit = droppingPoint?.isAllowCredit;

                // Set the corresponding state values
                // setdroppingPointId(droppingPointId);
                /*   setAgentId(agentId);
                  setCategoryId(categoryId);
                  setZoneId(zoneId);
                  setCounterId(counterId);
                  setRouteId(routeId); */
                setisAllowCredit(credit);
                setDroppingPointData(
                    //`Booth: ${droppingPoint.droppingPointCode} - ${droppingPoint.droppingPointName}\nAgent: ${droppingPoint.agentCode} - ${droppingPoint.agentName}\nRoute: Mor:${droppingPoint.morRouteName} / Eve:${droppingPoint.eveRouteName}\nCategory: ${droppingPoint.categoryName}  Zone: ${droppingPoint.zoneName}`
                    `Booth: ${droppingPoint.droppingPointCode} - ${droppingPoint.droppingPointName}       Route: Mor:${droppingPoint.morRouteName} / Eve:${droppingPoint.eveRouteName}\nAgent: ${droppingPoint.agentCode} - ${droppingPoint.agentName}    Category: ${droppingPoint.categoryName}  Zone: ${droppingPoint.zoneName}`

                );

                setFetchedProductList(product.map((item: any) => ({
                    ...item,
                    inEdit: true,
                    amount: (Number(item.morningQty) + Number(item.eveningQty)) * Number(item.baseRate),
                })));

                calculateTotalAmount(product);


                setTotalAmount(0.00);

                setShowGrid(true);
                setIsGetClicked(true);

            }
            else {
                setShowGrid(false);
                setDroppingPointData('');
                setModeOfPayment(0);
                setReference('');
                setReceivedAmount('');
                setTotalAmount(0);
                alert("No Data Found");
            }


            setModeOfPayment(0);
            setReference('');
            setReceivedAmount('');
            setReceiptId(0);

            if (isAllowCredit) {
                setModeOfPayment(5);
            }


        } catch (error) {
            console.error('Error fetching data:', error);
            setShowGrid(false);
        }
    };




    const handleConfirmOrder = () => {
        setIsUpdateMode(false);
        const isValidOrder = fetchedProductList.some(product =>
            product.morningQty > 0 || product.eveningQty > 0
        );
        /*  if (deliveryDate == orderDate) { */
        if (isValidOrder) {
            if (isAllowCredit === false) {
                if (modeOfPayment) {
                    if (reference == "" && modeOfPayment == 1 || reference) {
                        if (parseFloat(receivedAmount) >= totalAmount) {
                            setLoadingDetails(false);
                            setShowModal(true);
                            setModalTitle("Order Confirmation");
                            setModalLine1("Are you sure you want to confirm the order?");
                        }
                        else {
                            alert("Please check the Received Amount less than totalAmount ");
                        }
                    }
                    else {
                        alert("Please Select a Reference");
                    }
                } else {
                    alert("Please select a Payment Mode");
                }
            }
            else {
                setLoadingDetails(false);
                setShowModal(true);
                setModalTitle("Order Confirmation");
                setModalLine1("Are you sure you want to confirm the order?");
                //setModalLine2("TotalAmount")
            }
        }
        else {
            alert("Please Select Morning Quantity or Evening Quantity");
            setdroppingPointCode('');
            setDroppingPointData('');
        }
    };

    const handleCloseModal = () => {
        setShowModal(false); // Close the modal
    };

    const handleModedropdownChange = (event: { target: { value: any; }; }) => {
        setModeOfPayment(event.target.value);
        // alert(event.target.value) // Update selected option
    };
    const calculateTotalAmount = (data: any[]) => {
        console.log("Data:", data);
        const total = data.reduce((sum, item) => {
            const amount = parseFloat(item.amount);
            console.log("sum:", amount);
            return sum + (isNaN(amount) ? 0 : amount);
        }, 0);
        console.log("total a:", total)
        if (total) {
            setTotalAmount(total);
            if (isAllowCredit === false) {
                //alert("55")
                setReceivedAmount(total.toFixed(2));
            } else {
                setReceivedAmount('0');
            }
        }
        else {
            setTotalAmount(0.00);
        }
    };

    const totalOrderAmount = orderHistoryList.reduce((sum, item) => sum + item.receiptAmount, 0).toFixed(2);
    const orderCount = orderHistoryList.length;

    const handleEdit = (item: any) => {
        setSelectedItem(item);
        setShowModal(true);
        setIsDeleteMode(false);
        const isUpdate = item.droppingPointCode !== 0;
        setIsUpdateMode(isUpdate);
        if (isUpdate == true) {
            // alert(isUpdate)
            setModalTitle("Edit Order");
            setModalLine1("Do you want to edit this order?");
        }
        console.log('Editing item:', item);
        setdroppingPointCode(item.droppingPointCode);
        console.log(droppingPointCode);
        setOrderDate2(item.receiptDate);
        /*   setDeliveryDate2(item.deliveryDate); */
        if (item.deliveryDate) {
            const parsedDate = dayjs(item.deliveryDate, "ddd MMM DD YYYY").toDate();
            setDeliveryDate(parsedDate);
            setDeliveryDate2(item.deliveryDate);
        }
        console.log("d", deliveryDate2);
        // setModeOfPayment(item.name);
        // setReference(item.Reference);
        // setReceivedAmount(item.receivedAmount);
        // setTotalAmount(item.orderAmount);
    };


    const handleOkOrder = async () => {
        if (!selectedItem) return;

        setLoadingDetails(true);
        setShowModal(false);
        // setTotalAmount(selectedItem.orderAmount);
        try {
            await fetchData();

        } catch (error) {
            console.error("Error during proceed:", error);
        } finally {
            setLoadingDetails(false);
        }
    };

    const handleDelete = async (item: any) => {
        setIsUpdateMode(false);
        setIsDeleteMode(true);
        setSelectedItem(item);
        setModalTitle("Delete Confirmation");
        setModalLine1("Are you sure you want to delete?");
        setShowModal(true);

    }
    const handleDeleteOkOrder = async () => {
        if (!selectedItem) return;
        const getDeleteOrderUrl = getEndPoint(API_END_POINT.ORDER) + `/api/OrderMain/DeleteAgentOrder/${selectedItem.receiptId}`;
        try {

            const response = await getDataWithToken<any>(getDeleteOrderUrl);
            const res = response?.data?.result;
            if (res) {
                alert("Order Deleted Successfully");
                // getOrderHistoryList(selectedItem.receiptDate);
                await fetchData();
                setIsDeleteMode(false);
                setShowModal(false);
            } else {
                console.error("No order data found.");
            }
        } catch (error) {
            console.error('Error deleting order:', error);
        }
    }

    const handleQtyChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, type: string) => {
        const updatedList = [...fetchedProductList];
        const updatedItem = updatedList[index];

        let value = Number(e.target.value);
        if (isNaN(value) || value < 0) {
            value = 0;
        }
        if (type === 'morningQty') {
            updatedItem.morningQty = value;
        } else if (type === 'eveningQty') {
            updatedItem.eveningQty = value;
        }

        // Update amount after modifying quantities
        updatedItem.amount = (Number(updatedItem.morningQty) + Number(updatedItem.eveningQty)) * Number(updatedItem.baseRate);
        updatedList[index] = updatedItem;
        setFetchedProductList(updatedList);
        calculateTotalAmount(updatedList);
    };


    const handleProceedOrder = async () => {
        setLoadingDetails(true);
        setIsUpdateMode(false);
        try {
            // Define the two parameters to send in the request
            const OrderLine = fetchedProductList.map(product => ({
                productId: product.productId,
                productname: product.productName,
                basicrateperunit: product.baseRate,
                morningquantitypackets: product.morningQty,
                eveningquantitypackets: product.eveningQty,
                amount: product.amount,
                orderline_mid: product.orderLine_MId,
                orderline_eid: product.orderLine_EId,
                ordermain_mid: product.orderMain_MId,
                ordermain_eid: product.orderMain_EId,
                droppingpointid: product.droppingpointId,
                maingroupid: product.mainGroupId,
                subgroupid: product.subGroupId,
                productshortname: product.productShortName,
                morrouteid: product.morRouteId,
                everouteid: product.eveRouteId,
                cgstpercentage: product.cgstPercentage,
                sgstpercentage: product.sgstPercentage,
                igstpercentage: product.igstPercentage,
                cgstrateperunit: product.cgstRate,
                sgstrateperunit: product.sgstRate,
                igstrateperunit: product.igstRate,
                unitqty: product.unitQty,
                unitfactor: product.unitFactor,
                packetpertray: product.packetPerTray,
                orderDate: orderDate2,
                deliveryDate: deliveryDate2,
                orderNumber,
                agentId: product.agentId,
                categoryId: product.categoryId,
                zoneId: orderZoneId,
                routeId: product.routeId,
                counterId: orderCounterId,
                isDespatched,
                orderAmount: totalAmount,
                receivedAmount,
                discountAmount,
                orderMode: 1,
                type: 1

            }));

            const OrderReceipt = {
                receiptId: receiptId,
                paymentmode: modeOfPayment,
                receiptamount: receivedAmount,
                paymenttype: 1,
                counterId: orderCounterId,
                droppingPointId,
                agentId,
                reference: reference,
                receiptDate: orderDate2,
                orderAmount: totalAmount,
                paymentstatus: 1,
                receiptNumber: "REC001"
            };

            // const OrderReceipt = receiptList.map(recept => ({
            //         receiptId: receiptId,
            //         paymentmode: modeOfPayment,
            //         receiptamount: receivedAmount,
            //         paymenttype: 1,
            //         counterId: orderCounterId,
            //         droppingPointId,
            //         agentId,
            //         reference: reference,
            //         receiptDate: orderDate2,
            //         orderAmount: totalAmount,
            //         paymentstatus: 1,
            //         receiptNumber: "REC001"
            // }));

            // alert(JSON.stringify(OrderLine));
            // alert(JSON.stringify(OrderReceipt));
            const orderRequest = {
                OrderLine,
                OrderReceipt,
            };
            console.log(JSON.stringify(orderRequest));
            const response = await postData<any>(API_END_POINT.ORDER,
                "OrderMain/SaveOrder",
                "POST",
                "application/json",
                orderRequest,
            );
            console.log(response);
            //alert(response);
            if (response.status === 200) {

                alert("Order Confirmed Successfully!");
                setLoadingDetails(false);
                // setFetchedProductList([]);
                setFetchedProductList(prevProductList =>
                    prevProductList.map(product => ({
                        ...product,
                        morningQty: 0,
                        eveningQty: 0,
                        amount: 0
                    }))
                );
                setModeOfPayment(0);
                setReference('');
                setReceivedAmount('');
                setTotalAmount(0);
                setdroppingPointCode('');
                setDroppingPointData('');
                // getOrderHistoryList(orderDate2);

            } else {
                alert("Failed to Confirm the Order.");
            }


        } catch (error: any) {
            //console.error("Error confirming order:", error);
            if (error.response) {
                console.error("API Response Error:", error.response.data);
            }

            // alert("Error confirming the order.");
            // alert(JSON.stringify(error));
        } finally {
            setLoadingDetails(false);
            setShowModal(false); // Close the modal
        }
    };
return (
    <>
        <div className="dispatch-info-card">
            <div className="dispatch-info-item">
                <b>Booth:</b> A1188 - PRABU.R
            </div>
            <div className="dispatch-info-item">
                <b>Route:</b> Mor: PERAMBALUR / Eve: PERAMBALUR
            </div>
            <div className="dispatch-info-item">
                <b>Agent:</b> A1188 - PRABU.R
            </div>
            <div className="dispatch-info-item">
                <b>Category:</b> AGENT &nbsp;&nbsp; <b>Zone:</b> PERAMBALUR
            </div>
            <div className="dispatch-info-item">
                <b>Order Date:</b> 15-May-2025
            </div>
            <div className="dispatch-info-item">
                <b>Delivery Date:</b> 16-May-2025
            </div>
            <div className="dispatch-info-item">
                <b>Session:</b> Morning
            </div>
        </div>

        <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
            {/* Left side: Product Table */}
            <div
                style={{
                    flex: '1 1 70%',
                    marginRight: '10px',
                    visibility: isGetClicked ? 'visible' : 'hidden',
                    height: isGetClicked ? 'auto' : '0px',
                    overflow: 'hidden',
                }}
            >
                {isGetClicked && (
                    <>
                        {loadingDetails ? (
                            <p style={{ textAlign: "center", marginTop: "15px" }}>Loading...</p>
                        ) : (
                            <>
                                {showGrid ? (
                                    <>
                                        <div className="table-container">
                                            <table className="product-table" style={{ width: '100%' }}>
                                                <thead>
                                                    <tr>
                                                        <th>Code</th>
                                                        <th>Product</th>
                                                        <th style={{ textAlign: 'right' }}>Rate</th>
                                                        <th>Qty/Pkts</th>
                                                        <th style={{ textAlign: 'right' }}>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {fetchedProductList
                                                        .sort((a, b) => {
                                                            if (a.mainGroupId !== b.mainGroupId) {
                                                                return a.mainGroupId - b.mainGroupId;
                                                            }
                                                            if (a.subGroupId !== b.subGroupId) {
                                                                return a.subGroupId - b.subGroupId;
                                                            }
                                                            return a.unitQty - b.unitQty;
                                                        })
                                                        .map((product, index) => (
                                                            <tr key={index}>
                                                                <td>{product.code}</td>
                                                                <td>{product.productName}</td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    ₹ {product.baseRate.toFixed(3)}/Pkt
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        value={product.morningQty === 0 ? "" : product.morningQty}
                                                                        onChange={(e) => handleQtyChange(e, index, 'morningQty')}
                                                                        className="qty-input"
                                                                        onInput={(e) => {
                                                                            const inputValue = (e.target as HTMLInputElement).value;
                                                                            if (inputValue.length > 5) {
                                                                                (e.target as HTMLInputElement).value = inputValue.slice(0, 5);
                                                                            }
                                                                        }}
                                                                        style={{ borderColor: product.productColor, width: 100, padding: 2, textAlign: "right" }}
                                                                    />
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    ₹ {product.amount.toFixed(2)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div
                                            className="me-2"
                                            style={{ marginTop: '5px', marginRight: "105px", textAlign: 'right', fontSize: "17px" }}
                                        >
                                            <div><b>Total: ₹ {totalAmount.toFixed(2)}</b></div>
                                        </div>
                                    </>
                                ) : (
                                    <div
                                        style={{
                                            marginTop: "15px",
                                            fontSize: "16px",
                                            color: "#555",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                        }}
                                    >
                                        No data available
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>

            {/* Right side: Payment Section */}
            <div
                style={{
                    flex: '1 1 30%',
                    background: '#f9fafb',
                    border: '1px solid #e0e0e0',
                    borderRadius: '10px',
                    padding: '15px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    height: 'fit-content',
                    marginTop: isGetClicked ? 0 : '-9999px',
                    transition: 'margin-top 0.3s ease',
                }}
            >
                <div style={{ marginBottom: '10px' }}>
                    <label>Payment Mode</label>
                    <select
                        value={modeOfPayment}
                        onChange={handleModedropdownChange}
                        className="boothinput"
                        style={{ width: '100%' }}
                    >
                        <option value="">Please Select</option>
                        {modePayment.map((option) => (
                            <option key={option.label} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <label>Reference</label>
                    <input
                        name="reference"
                        className="boothinput"
                        value={reference}
                        onChange={handleChange}
                        style={{ width: '100%' }}
                    />
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <label>Received Amount</label>
                    <input
                        name="receivedAmount"
                        value={receivedAmount}
                        onChange={handleChange}
                        className="boothinput"
                        style={{ width: '100%' }}
                    />
                </div>
                <Button
                    className="btnOrderStyle"
                    style={{ width: '100%' }}
                    onClick={handleConfirmOrder}
                >
                    Confirm Order
                </Button>
            </div>
        </div>

        {/* Modal for Order Confirmation */}
        <Modal style={{ alignContent: "center" }} show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>{modalLine1}</h6>
                <h6>{modalLine2}</h6>
                {!isUpdateMode && !isDeleteMode && (
                    <p>Total Amount: ₹ {receivedAmount}</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                {isDeleteMode ? (
                    <>
                        <Button variant="secondary" onClick={handleCloseModal}>Cancel</Button>
                        <Button variant="danger" onClick={handleDeleteOkOrder}>Delete</Button>
                    </>
                ) : isUpdateMode ? (
                    <Button variant="primary" onClick={handleOkOrder}>OK</Button>
                ) : (
                    <>
                        <Button variant="secondary" onClick={handleCloseModal}>Back</Button>
                        <Button variant="primary" onClick={handleProceedOrder}>
                            {loadingDetails ? (
                                <>
                                    <span className="spinner-inline" /> Processing...
                                </>
                            ) : (
                                'Proceed'
                            )}
                        </Button>
                    </>
                )}
            </Modal.Footer>
        </Modal>
    </>
);

    }
export default DispatchEntryPage;
